import {
  STANDARD_ICON_SIZE,
  SMALL_ICON_SIZE,
  SMALLER_ICON_SIZE,
  EXTRA_SMALL_ICON_SIZE,
} from './constants'

export const iconSizes = {
  standard: STANDARD_ICON_SIZE,
  small: SMALL_ICON_SIZE,
  smaller: SMALLER_ICON_SIZE,
  extraSmall: EXTRA_SMALL_ICON_SIZE,
} as const
